import layout from "~/layout/App/Main.vue";
import auth from "../middleware/auth";

const cronsRoutes = {
  path: "/crons",
  component: layout,
  name: "crons",
  children: [
    {
      path: "",
      component: () => import("~/views/Cron/Index"),
      name: "crons.index",
      meta: {
        middleware: auth
      }
    },
    {
      path: "create",
      component: () => import("~/views/Cron/Create"),
      name: "crons.create",
      meta: {
        middleware: auth
      }
    },
    {
      path: "update",
      component: () => import("~/views/Cron/Edit.vue"),
      name: "crons.update",
      meta: {
        middleware: auth
      }
    }
  ]
};

export default cronsRoutes;
